import { RemarkButton } from '@Components/IconButton';
import Remark from '@Components/Remark';
import { useDisclosure } from '@hooks/useDisclosure';
import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';
import { useGreenhouseForm } from '../EsgGreenhouseFormProvider';
import { IPerformanceGhGasMgmtReportFormValues } from '../EsgGreenhouseFormProvider/types';

export const GH_GAS_MGMT_REPORT_REMARK_ID = 'gh-gas-mgmt-report-remark';

const GreenhouseGasMgmtReportRemark = () => {
  const { control, getValues } = useGreenhouseForm();
  const { remark } =
    getValues(`performanceGhGasMgmtReport`) ??
    ({} as IPerformanceGhGasMgmtReportFormValues);

  const [isRemarkOpen, { open, close }] = useDisclosure(!!remark);

  const ghGasMgmtReportRemarkEl = document.getElementById(
    GH_GAS_MGMT_REPORT_REMARK_ID
  );

  const { completedSection } =
    useWatch({
      name: 'performanceGhGasMgmtReport',
      control,
    }) ?? ({} as IPerformanceGhGasMgmtReportFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <RemarkButton onClick={open} disabled={isCompletedTh && isCompletedEn} />
      {isRemarkOpen &&
        ghGasMgmtReportRemarkEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              onDelete={close}
              topic="การรายงานผลการดำเนินงานและผลลัพธ์การจัดการก๊าซเรือนกระจก"
              setOpen={open}
              fieldPath="performanceGhGasMgmtReport.remark"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          ghGasMgmtReportRemarkEl
        )}
    </>
  );
};

export default GreenhouseGasMgmtReportRemark;
